/**
 * Andre Garen - Urun sayfasi.
 * Varyant secimi gercek Shopify verisiyle calisir (window.__AG_PRODUCT__ - JSON,
 * theme.liquid'in <head> kismindan degil, bu dosyanin altindan enjekte edilir).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-ag-product]');
  if (!root) return;

  var dataEl = document.getElementById('ag-product-data');
  var PRODUCT = null;
  try { PRODUCT = JSON.parse(dataEl.textContent); } catch (e) { PRODUCT = null; }
  if (!PRODUCT) return;

  var selected = PRODUCT.optionNames.map(function (_, i) {
    return PRODUCT.selected[i];
  });

  /* Tur 16-A: renk -> fotograf. Varyant JSON'unda mediaId (variant.featured_media), galeri ogelerinde
     data-ag-media-id var. Renk secilince (beden secilmemis olsa da) galeri o rengin fotografina kayar ve
     URL'ye ?variant= yazilir. Beden secilmeden yazilan URL history.state.agColorOnly ile isaretlenir:
     ayni sekmede yenilenince beden yine secilmemis baslar (T11-030 b korunur). */
  var colorIdx = -1;
  PRODUCT.optionNames.forEach(function (n, i) { if (colorIdx < 0 && (n === 'Renk' || n === 'Color')) colorIdx = i; });
  if (colorIdx > -1 && history.state && history.state.agColorOnly) {
    PRODUCT.optionNames.forEach(function (_, i) {
      if (i === colorIdx) return;
      var seen = {};
      PRODUCT.variants.forEach(function (x) { seen[x.options[i]] = 1; });
      if (Object.keys(seen).length > 1) selected[i] = null;
    });
  }

  function findVariant(sel) {
    for (var i = 0; i < PRODUCT.variants.length; i++) {
      var v = PRODUCT.variants[i];
      var match = true;
      for (var j = 0; j < sel.length; j++) {
        if (v.options[j] !== sel[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  /* Tur 12 D / T11-030 (b): null = henuz secilmemis secenek (beden) - joker gibi davranir.
     Tam belirli adaylarda eski findVariant(...).available kontroluyle ayni sonucu verir. */
  function anyAvailable(sel) {
    return PRODUCT.variants.some(function (v) {
      if (!v.available) return false;
      for (var j = 0; j < sel.length; j++) {
        if (sel[j] != null && v.options[j] !== sel[j]) return false;
      }
      return true;
    });
  }

  /* Secili renge ait varyant: tam secim varsa o, yoksa o rengin ilk stoktaki (yoksa ilk) varyanti. */
  function colorVariant() {
    var full = findVariant(selected);
    if (full || colorIdx < 0 || selected[colorIdx] == null) return full;
    var first = null;
    for (var i = 0; i < PRODUCT.variants.length; i++) {
      var x = PRODUCT.variants[i];
      if (x.options[colorIdx] !== selected[colorIdx]) continue;
      if (x.available) return x;
      if (!first) first = x;
    }
    return first;
  }

  function showVariantMedia(instant) {
    var cv = colorVariant();
    var g = root.querySelector('[data-ag-gallery]');
    if (!cv || !cv.mediaId || !g) return;
    var item = g.querySelector('.ag-gallery__item[data-ag-media-id="' + cv.mediaId + '"]');
    if (!item) return;
    /* Masaustu izgarasi (yatay kaydirma yok): rengin fotografi ilk (tam genislik) yere alinir. */
    if (g.scrollWidth <= g.clientWidth + 1) {
      if (g.firstElementChild !== item) g.insertBefore(item, g.firstElementChild);
      return;
    }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    g.scrollTo({ left: item.offsetLeft, behavior: instant || reduce ? 'auto' : 'smooth' });
  }

  /* Beden secilmemisse renge ait varyanti URL'ye yazar (tam secimde render() zaten yazar). */
  function syncColorUrl() {
    var cv = colorVariant();
    if (!cv || findVariant(selected) || !history.replaceState) return;
    var cu = new URL(window.location.href);
    cu.searchParams.set('variant', cv.id);
    history.replaceState({ agColorOnly: true }, '', cu);
  }

  function render() {
    var v = findVariant(selected);
    var unset = selected.indexOf(null) > -1;
    var atc = root.querySelector('.ag-product__atc');
    var priceWrap = root.querySelector('.ag-product__price');
    var stickyBtn = document.querySelector('[data-ag-stickyatc-btn]');
    var stickyPrice = document.querySelector('[data-ag-stickyatc-price]');

    root.querySelectorAll('[data-ag-option-index]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-ag-option-index'), 10);
      /* Denetim (Ürün Sayfası, mockup): "Beden X" cipi (asagida, Beden
         optgroup'unun icinde) de ayni data-ag-option-value oznitelinigi
         tasiyor - grup basina TEK degil, HERHANGI SAYIDA hedef guncellensin
         diye querySelector -> querySelectorAll'a cevrildi. */
      group.querySelectorAll('[data-ag-option-value]').forEach(function (valEl) {
        valEl.textContent = selected[idx] == null ? '\u2013' : selected[idx];
      });
      group.querySelectorAll('[data-ag-value]').forEach(function (btn) {
        var val = btn.getAttribute('data-ag-value');
        var isActive = val === selected[idx];
        /* Denetim (pre-launch audit, P1): eskiden hicbir yerde kullanilmayan
           optionAvailable() sadece "bu deger HERHANGI bir varyantta stokta mi"
           bakiyordu, secili digger secenekleri (orn. renk) yok sayiyordu -
           renk degisince tukenmis bedenler hala "stokta" gorunuyordu. Burada
           digger secimleri SABIT tutup sadece bu dugmenin degerini deneyen
           gercek bir kombinasyon kontrolu yapiliyor (findVariant zaten var). */
        var candidate = selected.slice();
        candidate[idx] = val;
        var isAvailable = anyAvailable(candidate);
        btn.classList.toggle('ag-swatch--active', isActive && btn.classList.contains('ag-swatch'));
        btn.classList.toggle('ag-size--active', isActive && btn.classList.contains('ag-size'));
        btn.classList.toggle('ag-size--out', !isAvailable && btn.classList.contains('ag-size'));
        btn.classList.toggle('ag-swatch--out', !isAvailable && btn.classList.contains('ag-swatch'));
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    });

    /* Denetim (pre-launch audit, P0): eskiden burada elle ABD bicimi
       (virgul binlik ayirici) ureten bir fmtMoney() vardi - magazanin gercek
       para birimi noktali ("17.470 ₺"). Artik sunucudan (Liquid, ayni
       money_without_trailing_zeros filtresiyle ag-price.liquid'in kullandigi)
       hazir bicimlenmis deger geliyor (priceFormatted/compareAtFormatted).
       Indirim rozeti (%discountPct) de eskiden burada TAMAMEN siliniyordu -
       priceWrap.innerHTML her render'da was/now span'lariyla degistiriliyordu
       ve rozet hic dahil edilmiyordu; simdi ayni innerHTML'e dahil. */
    if (priceWrap && v) {
      var html = '<span class="ag-price">';
      if (v.compareAtPrice && v.compareAtPrice > v.price) {
        html += '<span class="ag-price__was"><span class="ag-vh">Eski fiyat</span>' + v.compareAtFormatted + '</span>';
        html += '<span class="ag-price__now"><span class="ag-vh">İndirimli fiyat</span>' + v.priceFormatted + '</span>';
      } else {
        html += '<span class="ag-price__now">' + v.priceFormatted + '</span>';
      }
      html += '</span>';
      if (v.discountPct) {
        html += '<span class="ag-product__discount">%' + v.discountPct + '</span>';
      }
      priceWrap.innerHTML = html;
    }
    if (stickyPrice && v) stickyPrice.textContent = v.priceFormatted;

    /* Görev (Ürün Sayfası, mockup): Özet kartındaki iki "Toplam" satırı da
       seçili varyantla birlikte güncellenir - Kargo/Vergi zaten sabit
       ("Ücretsiz") metin, section ayarından geliyor, JS'e gerek yok. */
    if (v) {
      document.querySelectorAll('[data-ag-summary-price]').forEach(function (el) {
        el.textContent = v.priceFormatted;
      });
    }

    var notify = root.parentElement.querySelector('[data-ag-notify]');
    var scarcity = root.querySelector('[data-ag-scarcity]');

    if (v) {
      var sizeMsg = root.querySelector('[data-ag-size-msg]');
      if (sizeMsg) sizeMsg.hidden = true;
      [atc, stickyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.setAttribute('data-ag-add', v.id);
        btn.removeAttribute('data-ag-size-needed');
        if (v.available) {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
          btn.removeAttribute('data-ag-notify-trigger');
          /* Düzeltme (Ürün Sayfası, canlı test, 21 Eylül): render() burada
             textContent ile yazıyordu - Liquid'in ilk render'ında butona
             eklenen ok işareti (<span aria-hidden>→</span>, varyant
             değişiminde/sayfa yüklenişinde bu fonksiyon HER ZAMAN çalıştığı
             için) anında siliniyordu. innerHTML'e çevrildi, iki render yolu
             (Liquid ilk boya + bu JS) artık AYNI görünür sonucu üretiyor. */
          btn.innerHTML = PRODUCT.labels.add + ' <span aria-hidden="true">→</span>';
        } else {
          /* Tur 11: disabled/aria-disabled DEGIL - disabled bir button click uretmez, haber ver formu hic
             acilmiyordu. Sepete eklemeyi ag-cart.js data-ag-notify-trigger ile engeller. */
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
          btn.setAttribute('data-ag-notify-trigger', '1');
          btn.textContent = PRODUCT.labels.notify;
        }
      });
      if (scarcity) {
        if (v.available && v.inventoryManaged && v.inventoryQty > 0 && v.inventoryQty <= 2) {
          scarcity.hidden = false;
          scarcity.textContent = 'Bu bedende son ' + v.inventoryQty;
        } else {
          scarcity.hidden = true;
        }
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
    } else if (unset) {
      /* Tur 12 D / T11-030 (b): beden secilmedi - dugme etkin kalir ama sepete eklemez (bos data-ag-add,
         ag-cart.js bos id'yi yok sayar); tiklaninca uyari + beden satirina kaydirma (asagidaki click dinleyicisi). */
      [atc, stickyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('data-ag-notify-trigger');
        btn.setAttribute('data-ag-add', '');
        btn.setAttribute('data-ag-size-needed', '1');
      });
      if (scarcity) scarcity.hidden = true;
    } else {
      [atc, stickyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.removeAttribute('data-ag-notify-trigger');
        btn.textContent = PRODUCT.labels.notify;
      });
    }

    /* Tur 11: form gonderildikten sonra (basari/hata mesaji varsa) kutu acik kalir; not alanina secili beden yazilir. */
    if (notify) {
      /* Tur 23 EK3E: yalniz gorunen mesaj - basari satiri gizli basilir, kendi kancasinda (#AgSizeNotifyForm) acilir. */
      notify.hidden = !notify.querySelector('.ag-form-msg:not([hidden])');
      var note = notify.querySelector('[data-ag-notify-note]');
      if (note && v) {
        if (!note.getAttribute('data-base')) note.setAttribute('data-base', note.value);
        var base = note.getAttribute('data-base'); var k = base.indexOf(' \u2014 ');
        note.value = k > -1 ? base.slice(0, k) + ' \u2014 ' + v.options.join(' / ') + base.slice(k) : base;
      }
    }
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ag-option-set]');
    if (btn) {
      var idx = parseInt(btn.getAttribute('data-ag-option-set'), 10);
      var val = btn.getAttribute('data-ag-value');
      if (selected[idx] === val) {
        if (idx === colorIdx) syncColorUrl();
        return;
      }
      selected[idx] = val;
      render();
      if (idx === colorIdx) {
        showVariantMedia(false);
        syncColorUrl();
      }
      trackSizeFlip(idx);
      return;
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ag-size-needed]')) {
      var sizeMsg = root.querySelector('[data-ag-size-msg]');
      var sizeRow = root.querySelector('[data-ag-size-row]');
      if (sizeMsg) sizeMsg.hidden = false;
      if (sizeRow) {
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        sizeRow.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        var firstSize = sizeRow.querySelector('.ag-size:not(.ag-size--out)') || sizeRow.querySelector('.ag-size');
        if (firstSize) firstSize.focus({ preventScroll: true });
      }
      return;
    }
    if (e.target.closest('[data-ag-notify-trigger]')) {
      var notify = root.parentElement.querySelector('[data-ag-notify]');
      if (notify) { notify.hidden = false; notify.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
  });

  render();
  showVariantMedia(true);

  /* ---------------- galeri: kucuk-gorsel seridi (eski nokta gostergesinin yerini alir) ----------------
     Denetim (Ürün Sayfası, mockup): eski .ag-gallery__dots (salt gösterge,
     tıklanamaz) yerine tıklanabilir küçük-görsel şeridi - tıklayınca
     galeriyi o görsele kaydırır (scroll-snap zaten var, sadece programatik
     scrollTo), galerinin kendi 'scroll' dinleyicisi aktif thumb'ı senkron
     tutar - iki yönlü de çalışır (thumb tıkla -> galeri kayar, galeriyi
     kaydır -> doğru thumb aktifleşir). */
  var gallery = root.querySelector('[data-ag-gallery]');
  var thumbs = root.querySelectorAll('[data-ag-gallery-thumbs] .ag-gallery__thumb');
  var galleryCount = root.querySelector('[data-ag-gallery-count]'); /* Yukseltme 2 / H1 */
  function activeGalleryIndex() {
    if (!gallery || !gallery.clientWidth) return 0;
    return Math.round(gallery.scrollLeft / gallery.clientWidth);
  }
  if (gallery && thumbs.length) {
    gallery.addEventListener('scroll', function () {
      var i = activeGalleryIndex();
      if (galleryCount) galleryCount.textContent = (i + 1) + ' / ' + thumbs.length;
      thumbs.forEach(function (t, ti) {
        var active = ti === i;
        t.classList.toggle('ag-gallery__thumb--active', active);
        if (active) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }, { passive: true });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = parseInt(thumb.getAttribute('data-i'), 10) || 0;
        var item = gallery.querySelector('.ag-gallery__item[data-i="' + i + '"]');
        if (item) gallery.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      });
    });
  }

  /* ---------------- zoom lightbox (tap) ----------------
     Denetim: 1:1 detay karesi (data-ag-detailsquare) galerinin disinda ama
     ayni zoom katmanini kullaniyor - secici ve src-bulma mantigi genisletildi,
     kendi src'sini dogrudan elemanin ustunde (data-ag-zoom-src) tasiyor. */
  var zoom = document.querySelector('[data-ag-zoom]');
  function openZoomFor(item) {
    if (!item || !zoom) return;
    var src = item.getAttribute('data-ag-detail-src') || item.getAttribute('data-ag-zoom-src') || (item.querySelector('img') && item.querySelector('img').getAttribute('data-ag-zoom-src'));
    if (!src) return;
    var img = zoom.querySelector('[data-ag-zoom-img]');
    img.src = src;
    var caption = zoom.querySelector('[data-ag-zoom-caption]');
    if (caption) {
      var itemImg = item.querySelector('img');
      var alt = itemImg && itemImg.getAttribute('alt');
      caption.textContent = alt ? alt + ' · Yakınlaştırıldı' : '';
    }
    zoomOpener = document.activeElement;
    zoom.hidden = false;
    var zc = zoom.querySelector('[data-ag-zoom-close]');
    if (zc) zc.focus({ preventScroll: true });
  }
  /* Tur 16-A: Escape ile de kapanir (diger katmanlarla ayni), odak acan ogeye doner. */
  var zoomOpener = null;
  function closeZoom() {
    if (!zoom || zoom.hidden) return;
    zoom.hidden = true;
    var caption = zoom.querySelector('[data-ag-zoom-caption]');
    if (caption) caption.textContent = '';
    if (zoomOpener && zoomOpener.focus) zoomOpener.focus({ preventScroll: true });
    zoomOpener = null;
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeZoom();
    else if (e.key === 'Tab' && zoom && !zoom.hidden) { var f = [].filter.call(zoom.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; }); if (f.length) { e.preventDefault(); var i = f.indexOf(document.activeElement); f[i < 0 ? 0 : (i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus(); } }
  });
  document.addEventListener('click', function (e) {
    var item = e.target.closest('[data-ag-gallery] .ag-gallery__item, [data-ag-detailsquare]');
    if (!item) return;
    openZoomFor(item);
  });
  /* Görev (Ürün Sayfası, mockup): daire büyüteç düğmesi - o an görünen
     (galeri scroll konumundan) görseli açar, ayrı bir tıklama/src bulma
     mantığı yazılmadı - openZoomFor() yukarıdaki ile AYNI fonksiyon. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ag-gallery-zoom]')) return;
    if (!gallery) return;
    var i = activeGalleryIndex();
    var item = gallery.querySelectorAll('.ag-gallery__item')[i];
    openZoomFor(item);
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ag-zoom-close]') || e.target === zoom) closeZoom();
  });

  /* ---------------- atolye gorunumu: uzun basinca detay fotografina gec ---------------- */
  (function atelier() {
    var items = root.querySelectorAll('[data-ag-atelier]');
    var tag = root.querySelector('[data-ag-atelier-tag]');
    items.forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) return;
      var altSrc = item.getAttribute('data-ag-detail-src');
      var origSrc = img.src;
      var timer = null;
      var press = function () {
        timer = setTimeout(function () {
          if (tag) tag.classList.add('ag-gallery__atelier--on');
          item.classList.add('ag-gallery__item--peek');
        }, 420);
      };
      var release = function () {
        clearTimeout(timer);
        if (tag) tag.classList.remove('ag-gallery__atelier--on');
        item.classList.remove('ag-gallery__item--peek');
      };
      item.addEventListener('pointerdown', press);
      item.addEventListener('pointerup', release);
      item.addEventListener('pointerleave', release);
      item.addEventListener('pointercancel', release);
    });
  })();

  /* ---------------- akordeonlar (aciklama / kargo) zaten ag-ui.js'de ---------------- */

  /* ---------------- beden tablosu / quiz drawer ---------------- */
  /* Test Odasi H012: acan dugme hatirlanir; panel acilinca odak kapat dugmesine, kapaninca acan dugmeye doner (body'ye dusmez) */
  var panelAcan = {};
  function panel(sel, open, kaynak) {
    var el = document.querySelector(sel);
    if (!el) return;
    var once = el.hidden;
    if (open && once) panelAcan[sel] = kaynak || (document.activeElement !== document.body ? document.activeElement : null);
    el.hidden = !open;
    if (open && once) { var k = el.querySelector('.ag-filter__head [data-ag-chart-close], .ag-filter__head [data-ag-quiz-close], [role="dialog"] button'); if (k) k.focus({ preventScroll: true }); }
    if (!open && !once) { var a = panelAcan[sel]; panelAcan[sel] = null; if (a && a.isConnected && a.focus) a.focus({ preventScroll: true }); }
  }
  /* Yukseltme F (erisilebilirlik): Escape ile kapanis - ag-ui.js'deki
     filtre/sirala/ozel-gun panelleriyle AYNI desen; mevcut panel()
     yeniden kullaniliyor, yalnizca acik olan kapanir. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    ['[data-ag-chart]', '[data-ag-quiz]'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && !el.hidden) panel(sel, false);
    });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ag-chart-open]')) panel('[data-ag-chart]', true, e.target.closest('[data-ag-chart-open]'));
    if (e.target.closest('[data-ag-chart-close]')) panel('[data-ag-chart]', false);
    if (e.target.closest('[data-ag-ship-open]')) {
      var shipAcc = document.querySelector('[data-ag-shipping-accordion]');
      if (shipAcc) {
        shipAcc.setAttribute('data-open', '1');
        var toggleBtn = shipAcc.querySelector('[data-ag-accordion-toggle]');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
        setTimeout(function () { shipAcc.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 350);
      }
    }
    if (e.target.closest('[data-ag-quiz-open]')) panel('[data-ag-quiz]', true, e.target.closest('[data-ag-quiz-open]'));
    if (e.target.closest('[data-ag-quiz-close]')) panel('[data-ag-quiz]', false);

    var tab = e.target.closest('[data-ag-chart-tab]');
    if (tab) {
      var idx = tab.getAttribute('data-ag-chart-tab');
      document.querySelectorAll('[data-ag-chart-tab]').forEach(function (t) {
        t.classList.toggle('ag-chart__tab--active', t === tab);
      });
      document.querySelectorAll('[data-ag-chart-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-ag-chart-panel') !== idx;
      });
    }
  });

  /* ---------------- easter egg: ucuncu ziyaret ---------------- */
  (function thirdVisit() {
    try {
      var key = 'ag:pv:' + PRODUCT.handle;
      var n = parseInt(localStorage.getItem(key) || '0', 10) + 1;
      localStorage.setItem(key, String(n));
      if (n >= 3) {
        var el = root.querySelector('[data-ag-third-visit]');
        if (el) {
          var wa = PRODUCT.whatsappUrl;
          el.innerHTML = 'Üçüncü kez bakıyorsun.' + (wa ? ' <a href="' + wa + '" rel="noopener" target="_blank">Beden danışmanına yaz</a>' : '');
          el.hidden = false;
        }
      }
    } catch (e) {}
  })();

  /* ---------------- easter egg: beden kararsizligi (5x ileri geri) ---------------- */
  (function sizeIndecision() {
    var flips = 0;
    var lastIdx = null;
    var lastVal = null;
    window.__agTrackSizeFlip = function (idx) {
      var group = root.querySelector('[data-ag-option-index="' + idx + '"] [data-ag-size-row]');
      if (!group) return;
      flips++;
      if (flips >= 5) {
        var help = root.querySelector('[data-ag-sizehelp]');
        if (help && help.hidden) { help.hidden = false; panel('[data-ag-chart]', true); }
      }
    };
  })();
  function trackSizeFlip(idx) { if (window.__agTrackSizeFlip) window.__agTrackSizeFlip(idx); }

  /* ---------------- sabit Sepete Ekle seridi ----------------
     Denetim (Görev A5, Faz 8 Performans, 21 Eylul, KALDIRILDI): bar
     eskiden asil buton (.ag-product__atc) ekrandan cikinca IntersectionObserver
     ile "giren-cikan" bir animasyonla beliriyordu (transform/opacity .3s +
     overlayOpen() kontrolu) - "sayfa en ustteyken alttaki yapisma efekti"
     olarak raporlanan davranisin kaynagi buydu. Efekt + scroll'a bagli
     goster/gizle mantigi tamamen kaldirildi - bar artik ag-core.css'teki
     .ag-homebar gibi HER ZAMAN sabit/gorunur (bkz. ag-product-extra.css,
     .ag-stickyatc). IO/scroll dinleyicisi yok, JS maliyeti sifir. */

  /* ---------------- sticky baslik yigininin gercek yuksekligi ----------------
     .ag-product__trust'i bu yiginin hemen altina sabitlemek icin - mod
     sekmeleri ayarlardan acilip kapanabildigi icin sabit bir px degeri
     guvenilmez, gercek yukseklik JS ile olculuyor.
     Denetim (15 Eylul, Faz 8 Süsleme Paket 1, madde 01): tickerwrap
     hesaba KATILMIYOR artik - duyuru seridi artik sticky/fixed degil
     (normal akista, sayfa kaydikca yukari kayip gidiyor), sadece
     .ag-header2 (gercekten sticky kalan tek parca, top:0) olculuyor. */
  (function stickyHeaderHeight() {
    var header2 = document.querySelector('.ag-header2');
    var compactbar = document.querySelector('[data-ag-header-compactbar]');
    function measure() {
      /* Tur 18 (GZ2-02): kompakt basliga gecilince (data-ag-header-compact) yalniz kompakt cubuk ekranda kalir -> onun yuksekligini kullan. */
      var compact = document.documentElement.hasAttribute('data-ag-header-compact');
      var h = compact && compactbar && compactbar.offsetHeight ? compactbar.offsetHeight : (header2 ? header2.offsetHeight : 0);
      document.documentElement.style.setProperty('--ag-sticky-top', h + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    if (window.MutationObserver) new MutationObserver(measure).observe(document.documentElement, { attributes: true, attributeFilter: ['data-ag-header-compact'] });
  })();
})();